module.exports = __webpack_public_path__ + "img/from_toeicTest_content03.d3374051.svg";